/** Loading indicator for the global "loading" state (PRD Global States). */

import { cx } from './cx';

export type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  /** Visible caption; also the accessible name when rendered as a block. */
  label?: string;
  className?: string;
};

export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  if (label === undefined) {
    return (
      <span
        className={cx('spinner', `spinner--${size}`, className)}
        role="status"
        aria-label="Loading"
      />
    );
  }
  return (
    <div className={cx('spinner-block', className)} role="status">
      <span className={cx('spinner', `spinner--${size}`)} aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export default Spinner;
